import { useEffect } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

function Polygon({ paths, options }) {
  const map = useMap();
  const mapsLibrary = useMapsLibrary('maps');

  useEffect(() => {
    if (!map || !mapsLibrary || !paths || paths.length < 3) return;

    const polygon = new mapsLibrary.Polygon({
      paths: paths,
      ...options
    });

    polygon.setMap(map);

    return () => {
      polygon.setMap(null);
    };
  }, [map, mapsLibrary, paths, options]);

  return null;
}

export default Polygon;
